import {
	BillingAddressInfoLayout,
	BillingContext,
	BillingInfo,
	useBillingInfo,
} from '@shipstation/financial-services-ui-components';
import { Utils } from 'common';
import React, { useState } from 'react';

const { Session: SdcSession } = Utils;

export const BillingAddress = ({ accountBillingInfo }) => {
	const [currentBillingInfo, setCurrentBillingInfo] =
		useState(accountBillingInfo);
	const { setBillingInfo } = useBillingInfo();

	const handleBillingInfoChange = info => {
		setCurrentBillingInfo(info);
		setBillingInfo(info);
	};

	return (
		<BillingContext.Provider
			value={{
				billingInfo: currentBillingInfo,
				setBillingInfo: handleBillingInfoChange,
			}}
		>
			<BillingInfo previewLayout={BillingAddressInfoLayout.Default} />
		</BillingContext.Provider>
	);
};
